import React from 'react'
import t from '../translations/i18n'
import { Link } from 'react-router-dom'
import '../scss/footer.scss'

const AppFooter = () => {
  const currentYear = new Date().getFullYear()
  const copyrightText = `Copyright © ${currentYear} ${t(
    'branding.page_name'
  )}. Todos los derechos reservados.`

  return (
    <footer className="easybuy-footer">
      <div className="easybuy-footer-main">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-lg-4">
              <div className="easybuy-footer-column">
                <h4>{t('about.information')}</h4>

                <ul>
                  <li>
                    <Link to={global.ABOUT}>{t('about.about_easybuy')}</Link>
                  </li>

                  <li>
                    <Link to={global.CONTACT}>
                      {t('about.contact_easybuy')}
                    </Link>
                  </li>

                  <li>
                    <a href="#signin-modal" data-toggle="modal">
                      {t('auth.login_easybuy')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4 col-lg-4">
              <div className="easybuy-footer-column">
                <h4>{t('about.Custom_Service')}</h4>

                <ul>
                  <li>
                    <Link to={global.METODOPAGO}>
                      {t('shopping.PM_easybuy')}
                    </Link>
                  </li>

                  <li>
                    <Link to={global.GRANTIA}>
                      {t('shopping.Guarantee_easybuy')}
                    </Link>
                  </li>

                  <li>
                    <Link to={global.ENVIO}>
                      {t('shopping.Shipping_easybuy')}
                    </Link>
                  </li>

                  <li>
                    <Link to={global.TERMINOS}>{t('legal.use_term')}</Link>
                  </li>

                  <li>
                    <Link to={global.POLITICA}>
                      {t('legal.privacy_policy')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4 col-lg-4">
              <div className="easybuy-footer-column">
                <h4>{t('about.My_account')}</h4>

                <ul>
                  <li>
                    <a href="#signin-modal" data-toggle="modal">
                      {t('auth.sign_easybuy')}
                    </a>
                  </li>

                  <li>
                    <Link to={global.VIEWCART}>
                      {t('shopping.cart_easybuy')}
                    </Link>
                  </li>

                  <li>
                    <Link to={global.RASTREAPEDIDOS}>
                      {t('shopping.Tmyo_easybuy')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="easybuy-footer-bottom">
        <div className="container">
          <div className="easybuy-footer-bottom-content">
            <div className="easybuy-footer-copyright">{copyrightText}</div>

            <div className="easybuy-footer-social">
              <span>{t('social.social_icons')}</span>

              <div className="easybuy-social-icons">
                <a
                  href={t('social.social_face_url')}
                  rel="noreferrer"
                  title="Facebook"
                  target="_blank"
                >
                  <i className={t('social.social_face')}></i>
                </a>

                <a
                  href={t('social.social_x_url')}
                  rel="noreferrer"
                  title="Twitter"
                  target="_blank"
                >
                  <i className={t('social.social_x')}></i>
                </a>

                <a
                  href={t('social.social_ins_url')}
                  rel="noreferrer"
                  title="Instagram"
                  target="_blank"
                >
                  <i className={t('social.social_ins')}></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default AppFooter
